export default "__VITE_ASSET__2edb36ee__"